/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuthTokenRevokeReq
 */
export interface OAuthTokenRevokeReq {
    /**
     * The client ID originally used to obtain the token from the IdP
     * @type {string}
     * @memberof OAuthTokenRevokeReq
     */
    client_id: string;
    /**
     * The token to be revoked
     * @type {string}
     * @memberof OAuthTokenRevokeReq
     */
    token: string;
    /**
     * The type of token being revoked, either access or refresh
     * @type {OAuthTokenRevokeReqTokenTypeEnum}
     * @memberof OAuthTokenRevokeReq
     */
    token_type: OAuthTokenRevokeReqTokenTypeEnum;
}


/**
 * @export
 */
export const OAuthTokenRevokeReqTokenTypeEnum = {
    AccessToken: 'access_token',
    RefreshToken: 'refresh_token'
} as const;
export type OAuthTokenRevokeReqTokenTypeEnum = typeof OAuthTokenRevokeReqTokenTypeEnum[keyof typeof OAuthTokenRevokeReqTokenTypeEnum];


/**
 * Check if a given object implements the OAuthTokenRevokeReq interface.
 */
export function instanceOfOAuthTokenRevokeReq(value: object): value is OAuthTokenRevokeReq {
    if (!('client_id' in value) || value['client_id'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('token_type' in value) || value['token_type'] === undefined) return false;
    return true;
}

export function OAuthTokenRevokeReqFromJSON(json: any): OAuthTokenRevokeReq {
    return OAuthTokenRevokeReqFromJSONTyped(json, false);
}

export function OAuthTokenRevokeReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthTokenRevokeReq {
    if (json == null) {
        return json;
    }
    return {
        
        'client_id': json['client_id'],
        'token': json['token'],
        'token_type': json['token_type'],
    };
}

export function OAuthTokenRevokeReqToJSON(json: any): OAuthTokenRevokeReq {
    return OAuthTokenRevokeReqToJSONTyped(json, false);
}

export function OAuthTokenRevokeReqToJSONTyped(value?: OAuthTokenRevokeReq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_id': value['client_id'],
        'token': value['token'],
        'token_type': value['token_type'],
    };
}

